module.exports = __webpack_public_path__ + "assets/mp3/audio8/audio_8_2.mp3";